import { render, staticRenderFns } from "./slack.vue?vue&type=template&id=712e497d&"
import script from "./slack.vue?vue&type=script&lang=js&"
export * from "./slack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports